export const SubSwapName = "bit"

// 修改点：二级swap的名称
// key：
// bit
// btn10086
// main
// dev